export enum OptionStrategies {
  Strangle = 'Strangle',
  Straddle = 'Straddle',
  VerticalSpread = 'Vertical Spread',
  CalendarSpread = 'Calendar Spread',
  Butterfly = 'Butterfly',
}
